import { apiLogin } from '@/services';

export const SecurityService = {
  loginCheck(payload) {
    return apiLogin.post('/login_check', payload);
  },
  loginOsKeyCheck(payload) {
    return apiLogin.post('/login_os_key_check', payload);
  },
};